import { useFormik } from 'formik';
import * as yup from 'yup';
import { useAuth } from '../contexs/auth-context';
import { TIP_PAYMENT_METHODS, useT } from '../utils/helper';
import { CreateTipInvoiceParams } from '../api/types/tip_invoice.types';

const useTipInvoiceForm = (
  onSubmit: (params: CreateTipInvoiceParams) => void,
) => {
  const { currentCashier } = useAuth();
  const t = useT('forms');

  const tipInvoiceSchema = yup.object().shape({
    cashier_id: yup
      .number()
      .typeError(t('mustBeNumber').toString())
      .required(t('requiredField').toString()),
    payment_method: yup
      .string()
      .required(t('requiredField').toString())
      .oneOf(TIP_PAYMENT_METHODS, t('invalidPaymentMethod').toString()),
    tip_amount: yup
      .number()
      .typeError(t('mustBeNumber').toString())
      .required(t('requiredField').toString())
      .min(0, t('minZero').toString()),
  });

  type FormContents = yup.InferType<typeof tipInvoiceSchema>;

  const form = useFormik({
    initialValues: {
      cashier_id: currentCashier?.id,
    } as FormContents,
    initialTouched: {},
    validationSchema: tipInvoiceSchema,
    validateOnBlur: true,
    validateOnMount: true,
    enableReinitialize: true,
    onSubmit,
  });

  return form;
};

export { useTipInvoiceForm };
